import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { RootState } from "../../../redux/store";
import {
  setloadeActive,
  setloadeDeactive,
} from "../../../redux/loader/loaderActions";
import baseUrl from "../../../api/baseUrl";
import FormDate from "../../../components/formFeild/FormDate";
import BottomTab from "../../../components/pagination/BottomTab";
import AllPaymentReport from "../payments/allpayments/AllPaymentReport";
import CommonLayout from "../../../layouts/commonLayout/CommonLayout";
import PaymentCount from "./PaymentCount";
interface FormData {
  payments: boolean;
  startDate: string;
  endDate: string;
}
function AllPaymentList() {
  const navigate = useNavigate();
  const [report, setreport] = useState(false);
  const [, setopenpayments] = useState(false);
  const [payment, setpayment] = useState([]);
  const [count, setCount] = useState(0);
  const [allcount, setallCount] = useState({});
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState<string>("");
  const search = useSelector((state: RootState) => state.searching.patientData);
  const methods = useForm<FormData>();
  const { watch, reset } = methods;
  const dispatch = useDispatch();
  const getData = useCallback(
    (
      searchTerm: string,
      pageNum?: number,
      startDate?: string,
      endDate?: string
    ) => {
      dispatch(setloadeActive());

      baseUrl
        .get("payment/getAllPayment-list", {
          headers: {
            keyword: searchTerm,
            page: pageNum,
          },
          params: {
            startDate: startDate,
            endDate: endDate,
          },
        })
        .then((response) => {
          dispatch(setloadeDeactive());
          setallCount(response.data.allcount);
          setpayment(response.data.data);
          setCount(response.data.count);
        })
        .catch((error) => {
          dispatch(setloadeDeactive());
        });
    },
    [dispatch]
  );
  useEffect(() => {
    // Use searchTerm if available, otherwise fall back to Redux search
    const activeSearchTerm = searchTerm || search || "";
    getData(activeSearchTerm, page);
  }, [search, searchTerm, page, getData]);
  useEffect(() => {
    const { unsubscribe } = watch((value) => {
      if (value.startDate && value.endDate)
        getData(searchTerm || search || "", page, value.startDate, value.endDate);
      if (value.payments) {
        setopenpayments(true);
      } else {
        setopenpayments(false);
      }
    });
    return () => unsubscribe();
  }, [watch, searchTerm, search, page, getData]);
  const onPageChange = useCallback(
    (newPage: number) => {
      setPage(newPage);
      const activeSearchTerm = searchTerm || search || "";
      getData(activeSearchTerm, newPage);
    },
    [getData, searchTerm, search]
  );
  const closeModal = useCallback(() => {
    setreport(false);
  }, []);
  const onSubmit: SubmitHandler<FormData> = useCallback(
    async (data) => {
      try {
        const response = await baseUrl.get("client/payment/payment-report", {
          responseType: "blob",
          params: {
            startDate: data.startDate,
            endDate: data.endDate,
          },
        });
        if (response.status === 204) {
          toast("No data found");
          return;
        }
        const pdfBlob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(pdfBlob);
        link.download = "downloaded.pdf";
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error downloading the PDF", error);
      }
    },
    []
  );
  const methodReset = useCallback((e: any) => {
    e.preventDefault();
    reset();
    setSearchTerm("");
    setPage(1);
    getData("", 1);
  }, [getData, reset]);
  const handleSearch = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    setPage(1); // Reset to first page on new search
    getData(value, 1);
  }, [getData]);
  return (
    <CommonLayout>
      <div className="mt-6 space-y-3">
        <PaymentCount count={allcount} />
        <div className="bg-white dark:bg-slate-800 rounded-[8px] shadow-lg shadow-slate-200/50 dark:shadow-slate-900/50 border border-slate-100 dark:border-slate-700 p-4">
          {/* Filter Form */}
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)} className="flex flex-col sm:flex-row flex-wrap items-end gap-3 mb-3">
              <div className="w-full sm:w-36 shrink-0">
                <input
                  type="search"
                  placeholder="Search invoice, patient, dentist..."
                  value={searchTerm}
                  onChange={handleSearch}
                  className="w-full h-8 pl-2.5 pr-2 rounded-lg border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-800 text-slate-700 dark:text-slate-200 placeholder-slate-400 dark:placeholder-slate-500 outline-none focus:outline-none transition-all text-xs"
                />
              </div>
              <div className="flex gap-3 shrink-0 flex-nowrap">
                <FormDate label="From" name="startDate"  />
                <FormDate label="To" name="endDate"  />
              </div>
              <div className="flex gap-2 shrink-0">
                <button
                  type="submit"
                  className="h-8 px-3 rounded-lg bg-gradient-to-r from-primary to-primaryLight text-white font-medium hover:shadow-lg hover:shadow-primary/20 transition-all text-xs"
                >
                  Download PDF
                </button>
                <button
                  onClick={methodReset}
                  className="h-8 px-3 rounded-lg bg-slate-100 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 text-slate-600 dark:text-slate-300 font-medium hover:bg-slate-200 dark:hover:bg-slate-600 transition-colors text-xs"
                >
                  Reset
                </button>
              </div>
            </form>
          </FormProvider>

          {/* Desktop Table */}
          <div className="hidden md:block overflow-hidden rounded-lg border border-slate-200 dark:border-slate-600">
            <table className="w-full">
              <thead className="bg-slate-50 dark:bg-slate-700/50 border-b border-slate-100 dark:border-slate-600">
                <tr>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase">Invoice No</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase">Date</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase">Patient</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase">Dentist</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase">Total</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase">Card</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase">Cash</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase">Bank</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase">Discount</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase">paid</th>
                  <th className="px-3 py-2 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase">Due/Adv</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-slate-600">
                {payment.map((item: any, index) => (
                  <tr
                    key={index}
                    onClick={() => navigate(`/client/payments/invoice/${item?.treatmentId}`)}
                    className="hover:bg-slate-50 dark:hover:bg-slate-700/50 cursor-pointer transition-colors"
                  >
                    <td className="px-3 py-2 text-xs font-medium text-indigo-600 dark:text-indigo-400">{item?.invoiceNo}</td>
                    <td className="px-3 py-2 text-xs text-slate-600 dark:text-slate-400">{item?.updatedAt?.split("T")[0]}</td>
                    <td className="px-3 py-2 text-xs font-medium text-slate-800 dark:text-slate-200">{item?.patientName}</td>
                    <td className="px-3 py-2 text-xs text-slate-600 dark:text-slate-400">{item?.doctorName}</td>
                    <td className="px-3 py-2 text-xs text-slate-600">{item?.payable}</td>
                    <td className="px-3 py-2 text-xs font-semibold text-emerald-600">{item?.card}</td>
                    <td className="px-3 py-2 text-xs font-semibold text-emerald-600">{item?.cash}</td>
                    <td className="px-3 py-2 text-xs font-semibold text-emerald-600">{item?.bankTransfer}</td>

                    <td className="px-3 py-2 text-xs text-orange-600">{item?.discount}</td>
                    <td className="px-3 py-2 text-xs font-semibold text-emerald-600">{item?.cash + item?.card + item?.bankTransfer}</td>
                    <td className={`px-3 py-2 text-xs font-semibold ${item?.due > 0 ? "text-red-600" : "text-emerald-600"}`}>
                      {item?.due}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="md:hidden space-y-2">
            {payment.map((item: any, index) => (
              <div
                key={index}
                onClick={() => navigate(`/client/payments/invoice/${item?.treatmentId}`)}
                className="bg-slate-50 dark:bg-slate-800 rounded-lg p-3 cursor-pointer hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors"
              >
                <div className="flex items-center justify-between mb-1.5">
                  <span className="font-medium text-xs text-indigo-600 dark:text-indigo-400">{item?.invoiceNo}</span>
                  <span className="text-[10px] text-slate-500 dark:text-slate-400">{item?.updatedAt?.split("T")[0]}</span>
                </div>
                <h3 className="font-semibold text-xs text-slate-800 dark:text-slate-200 mb-1.5">{item?.patientName}</h3>
                <div className="grid grid-cols-3 gap-1.5 text-xs">
                  <div className="bg-white dark:bg-slate-700 rounded-md p-1.5 text-center">
                    <p className="text-[10px] text-slate-500 dark:text-slate-400">Total</p>
                    <p className="font-semibold text-slate-700 dark:text-slate-300">{item?.payable}</p>
                  </div>
                  <div className="bg-emerald-50 dark:bg-emerald-900/30 rounded-md p-1.5 text-center">
                    <p className="text-[10px] text-emerald-600 dark:text-emerald-400">Paid</p>
                    <p className="font-semibold text-emerald-700 dark:text-emerald-400">{item?.cash + item?.card + item?.bankTransfer}</p>
                  </div>
                  <div className={`rounded-md p-1.5 text-center ${item?.due > 0 ? "bg-red-50 dark:bg-red-900/30" : "bg-emerald-50 dark:bg-emerald-900/30"}`}>
                    <p className={`text-[10px] ${item?.due > 0 ? "text-red-600 dark:text-red-400" : "text-emerald-600 dark:text-emerald-400"}`}>
                      {item?.due > 0 ? "Due" : "Adv"}
                    </p>
                    <p className={`font-semibold ${item?.due > 0 ? "text-red-700 dark:text-red-400" : "text-emerald-700 dark:text-emerald-400"}`}>{item?.due}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <BottomTab title="Patient" count={count} onPageChange={onPageChange} />
          {report && <AllPaymentReport closeModal={closeModal} />}
        </div>
      </div>
    </CommonLayout>
  );
}

export default AllPaymentList;
